<template>
  <div class="deco-toolbar">
    <!-- デザイン切り替え (該当グループが複数ある時のみ) -->
    <button v-if="decoDataStore.hasMultipleDesignGroups" class="toolbar-btn" @click="uiStore.showPanel('design')">
      <img src="/img/btDeco_5.png" class="toolbar-icon toolbar-icon--invert" alt="">
      <span class="toolbar-label">デザイン</span>
    </button>

    <!-- 写真を選ぶ -->
    <button v-if="!hints.hidePictureButton" class="toolbar-btn" @click="triggerFileInput">
      <img src="/img/btDeco_1.png" class="toolbar-icon" alt="">
      <span class="toolbar-label">写真</span>
      <input
        ref="fileInputRef"
        type="file"
        accept="image/*"
        style="display:none"
        @change="onFileChange"
      />
    </button>

    <!-- フレーム -->
    <button v-if="!hints.hideFrameButton" class="toolbar-btn" @click="uiStore.showPanel('frame')">
      <img src="/img/btDeco_2.png" class="toolbar-icon" alt="">
      <span class="toolbar-label">フレーム</span>
    </button>

    <!-- スタンプ -->
    <button v-if="!hints.hideStampButton" class="toolbar-btn" @click="uiStore.showPanel('stamp')">
      <img src="/img/btDeco_3.png" class="toolbar-icon" alt="">
      <span class="toolbar-label">スタンプ</span>
    </button>

    <!-- 文字 -->
    <button v-if="!hints.hideTextButton" class="toolbar-btn" @click="openText">
      <img src="/img/btDeco_4.png" class="toolbar-icon" alt="">
      <span class="toolbar-label">文字</span>
    </button>

    <!-- 履歴 (ログイン済みのみ) -->
    <button v-if="decoDataStore.isAuthenticated && !hints.hideHistoryButton" class="toolbar-btn" @click="uiStore.showPanel('history')">
      <img src="/img/btDeco_7.png" class="toolbar-icon" alt="">
      <span class="toolbar-label">履歴</span>
    </button>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useCanvasStore } from '../../stores/useCanvasStore'
import { useUiStore } from '../../stores/useUiStore'
import { useTextStore } from '../../stores/useTextStore'
import { useDecoDataStore } from '../../stores/useDecoDataStore'
import { fileToDataUrl, loadImage } from '../../composables/useImageLoader'

const canvasStore = useCanvasStore()
const uiStore = useUiStore()
const textStore = useTextStore()
const decoDataStore = useDecoDataStore()
const fileInputRef = ref(null)

// defaultDesign の ui ヒント (適用グループ全体を OR で合成済み)
const hints = computed(() => decoDataStore.mergedUiHints)

function triggerFileInput() { fileInputRef.value?.click() }

async function onFileChange(e) {
  const file = e.target.files?.[0]
  if (!file) return
  if (canvasStore.cntPicture >= canvasStore.maxPicture) return
  e.target.value = ''

  uiStore.setLoading(true)
  try {
    const dataUrl = await fileToDataUrl(file)
    const img = await loadImage(dataUrl)
    const size = canvasStore.canvasSize
    const ratio = img.naturalWidth / img.naturalHeight
    const max = size * 0.6
    const w = ratio >= 1 ? max : max * ratio
    const h = ratio >= 1 ? max / ratio : max
    canvasStore.addObject({
      objectType: 'picture',
      src: dataUrl,
      x: canvasStore.labelCenterX,
      y: canvasStore.labelCenterY,
      width: w,
      height: h,
      rotation: 0,
      naturalWidth: img.naturalWidth,
      naturalHeight: img.naturalHeight,
    })
  } finally {
    uiStore.setLoading(false)
  }
}

function openText() {
  textStore.openNew()
  uiStore.showPanel('text')
}
</script>
